// removed by extract-text-webpack-plugin
module.exports = {"bundle":"_1Ja5XRoWPLPpLMlqqx-as9","tips":"_3UgN_ttLp42gFLeVYwBhzL"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/BundleList/index.less
// module id = 406
// module chunks = 0